import {useRouteMatch} from 'react-router-dom';
import {Grid} from 'semantic-ui-react';

import GeneralInfo from 'components/Common/GeneralInfo/GeneralInfo';

import GitlabPages from './GitlabPagesSite/GitlabPages';

import styles from './GitlabPagesSite.module.scss';

const GitlabPagesSite = () => {
  let {
    params: {projectName},
  } = useRouteMatch();

  const message = (
    <>
      You are about to delete the site "<strong>{projectName}</strong>". This operation can not be
      undone. Are you sure that you want to proceed? Please note that it may take some time for the
      URL(s) to be available for reuse again.
    </>
  );

  return (
    <>
      <Grid centered>
        <Grid.Column className={styles.GitlabPagesSite}>
          <GeneralInfo projectName={projectName} projectType="gps" removeProjectMessage={message} />
          <GitlabPages projectName={projectName} />
        </Grid.Column>
      </Grid>
    </>
  );
};

export default GitlabPagesSite;
